import Actions from './collection-actions';
import Api from './collection-api';
import Collection from './collection-collection';
import Model from './collection-model';
import reducer from './collection-reducer';
import sagas, { fetchCollection } from './collection-sagas';
import Selectors from './collection-selectors';

export default {
  Actions,
  Api,
  Collection,
  Model,
  namespace: 'collection',
  reducer,
  sagas:     [sagas],
  Selectors,
  Utils:     {
    fetchCollection,
  },
};
